import React from 'react';
import { useHistory } from "react-router-dom";
import BreadCrumbs from '../../Common/BreadCrumbs';
import {
    PrimaryButton,
} from '../../Common';

const Error404 = ({

}) => {

    const history = useHistory();

    return (
        <>
            <BreadCrumbs
                path={[
                    { text: `Page Not Found`, onClick: null }
                ]}
            />

            <div className="flex f-col f-center">

                <img src="/images/Error404.svg" />

                <br />

                <p className="error404-text">You did not break the internet, but we could not find what you were looking for.</p>

                <br />

                <p className="error404-text-small">Contact our support team if you need assistance.</p>

                <br/>

                <PrimaryButton
                    buttonText={"Go Back Home"}
                    onClick={() => history.push('/')}
                />
            </div>

        </>
        
    );
};

export default Error404;
